import { useContext } from 'react';

import { AuthFormContext } from '.';

export function useAuthFormContext() {
    const context = useContext(AuthFormContext);

    if (!context) {
        throw new Error(
            'useAuthFormContext must be used within a AuthFormProvider',
        );
    }

    return context;
}
